<div class="divider">
  <span class="divider__line" aria-hidden="true"></span>
  <span class="divider__label">{{ label }}</span>
  <span class="divider__line" aria-hidden="true"></span>
</div>
